import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  questions: [],
};

export const questionSlice = createSlice({
  name: "Question",
  initialState,
  reducers: {
    setQuestion: (state, action) => {
      state.questions = action.payload;
    },
  },
});

export const { setQuestion} = questionSlice.actions;
export const questionReducer = questionSlice.reducer;